import PropTypes from 'prop-types';
import React from 'react';

import Image from '$partials/media/image';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleTeamBlock = ({
    heading,
    teamItems,
    isAccordionOrSection,
    isFirstInAccordion
}) => {

    return (
        <section className='relative'>
            <div className='layout-container'>
                <div className='layout-grid-negative-gutter md:flex'>
                    <div className='md:w-1/12 layout-grid-col-padding' />
                    <div className='md:w-11/12 layout-grid-col-padding'>
                        <div className={`${isAccordionOrSection && !isFirstInAccordion ? 'border-t border-t-charcoal' : ''}`} />
                    </div>
                </div>
            </div>

            <div className='layout-container'>
                <div className='layout-grid-negative-gutter md:flex'>
                    <div className='md:w-1/12 layout-grid-col-padding' />
                    <div className='md:w-11/12 sm:flex'>
                        {heading && (
                            <h2 className='layout-grid-col-padding sm:w-4/12 md:w-4/11 type-style-3 py-35'>
                                {heading}
                            </h2>
                        )}
                    </div>
                </div>
            </div>

            <div className='layout-container mb-20 md:mb-80'>
                <div className='layout-grid-negative-gutter md:flex'>
                    <div className='md:w-1/12 layout-grid-col-padding' />
                    <div className='md:w-11/12 flex flex-wrap'>
                        {teamItems?.length > 0 && teamItems.filter(item => item.page).map((item, idx) => {
                            return (
                                <div
                                    className='expand-interaction layout-grid-col-padding basis-6/12 sm:basis-3/12 md:basis-2/11 pb-40'
                                    key={idx}>
                                    <Image
                                        {...item.page?.image}
                                        alt={`Image of ${item.page.title}`} />

                                    <h3 className='type-style-3 pt-20 md:pt-30'>
                                        <a
                                            className='expand-interaction__action'
                                            href={item.page.url}>{item.page.title}</a>
                                    </h3>

                                    <p className='type-style-4 pt-15'>{item.page.role}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    heading: PropTypes.string,
    teamItems: PropTypes.array,
    isAccordionOrSection: PropTypes.bool,
    isFirstInAccordion: PropTypes.bool,
};

ModuleTeamBlock.propTypes = propTypes;

export default ModuleTeamBlock;
